import React, { useContext, useEffect, useRef, useState } from 'react';
import { CustomInput, Input, Label } from 'reactstrap';
import { QUESTION_ANSWER } from 'constants/constants';
import { useUnit } from 'hooks/units/index';
import { getThemeColor } from 'store/settings';
import { useSelector } from 'react-redux';
import { parseHtml } from 'helpers';
import { Popover } from 'antd';
import styles from 'styles/Calendar.module.scss';
import useWindowSize from 'hooks/useWindowSize';
import { UnitIdContext } from 'pages/course/[slug]/unit/[unitId]';
import { HelpCircle } from 'react-feather';

const MultipleChoice = ({
  question,
  test,
  multi,
  setMulti,
  questionArray,
  setQuestionArray,
}) => {
  const unitSelected = useUnit();
  const [firstAttempt, setFirstAttempt] = useState(false);
  const [radioChecked, setRadioChecked] = useState('');
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const isFullscreenMode = useContext(UnitIdContext);

  const handleAnswerValue = (answer) => {
    let array = [...questionArray];
    questionArray?.forEach((element, index) => {
      if (element._id === question?._id) {
        let obj = { ...element };
        obj.answerValue = [...obj.answerValue, answer];
        array.splice(index, 1, obj);
      }
      setQuestionArray(array);
    });
  };

  const listAnswer =
    question?.answers ||
    question?.data ||
    unitSelected?.complete?.question?.answers;
  const answerHandler = (index) => {
    return multi?.length && multi[index] == true ? true : false;
  };
  //color-theme
  const themeStatus = useSelector(getThemeColor);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  useEffect(() => {
    let array = [];
    if (test?.userQuestion?.result?.length) {
      test?.userQuestion?.result?.map((dt) => {
        array.push(false);
      });
    }
    if (test) {
      (question?.typeAnswer || unitSelected?.complete?.question?.typeAnswer) ===
      QUESTION_ANSWER.RADIO
        ? test?.userQuestion?.result?.map(
            (dt, i) =>
              dt == true && setMulti(test?.userQuestion?.resultAnswers[i]),
          )
        : test?.userQuestion?.reAttempt &&
          !test?.userQuestion?.reAttempted &&
          test?.userQuestion?.status !== 'DRAFT' &&
          !firstAttempt
        ? setMulti(array)
        : setMulti(test?.userQuestion?.result);
    }
  }, [test]);

  const handler = (index) => {
    if (multi?.length) {
      let array = [];
      multi?.map((dt, i) => {
        if (index == i) {
          dt = !dt;
        }
        array.push(dt);
      });
      setMulti(array);
    }
  };

  const changeHandler = (value) => {
    if (multi?.length) {
      let dt = [];
      multi?.map((i) => dt.push(i));
      dt.push(value);
      setMulti(dt);
    } else {
      setMulti([value]);
    }
  };

  const styleCheckBoxTrue =
    (question?.typeAnswer || unitSelected?.complete?.question?.typeAnswer) ===
    QUESTION_ANSWER.RADIO
      ? {
          backgroundColor: `${themeStatus}`,
          borderColor: `${themeStatus}`,
        }
      : {
          accentColor: `${themeStatus}`,
          height: 16,
          width: 16,
          marginTop: 0,
        };
  const styleCheckBoxFalse =
    (question?.typeAnswer || unitSelected?.complete?.question?.typeAnswer) ===
    QUESTION_ANSWER.RADIO
      ? { backgroundColor: '', borderColor: '' }
      : {
          accentColor: `${themeStatus}`,
          height: 16,
          width: 16,
          marginTop: 0,
        };

  return (
    <>
      <div className="mt-1">
        {unitSelected?.type == 'DOCUMENT' ||
        unitSelected?.type == 'VIDEO' ||
        unitSelected?.type == 'AUDIO' ||
        unitSelected?.type == 'CONTENT' ||
        unitSelected?.type == 'IFRAME' ||
        unitSelected?.type == 'LTI' ||
        unitSelected?.type == 'SURVEY'
          ? listAnswer?.map((answer, index) => (
              <Label className="col multiple-checkbox explanation-card pr-0">
                <Input
                  key={index}
                  className="custom-control-Primary"
                  onChange={() => {
                    setRadioChecked(answer);
                    questionArray?.length && handleAnswerValue(answer);
                  }}
                  type={
                    (question?.typeAnswer ||
                      unitSelected?.complete?.question?.typeAnswer) ===
                    QUESTION_ANSWER.RADIO
                      ? 'radio'
                      : 'checkbox'
                  }
                  id={`MTP-${index}`}
                  name="MTP"
                  style={
                    radioChecked == answer
                      ? { ...styleCheckBoxTrue }
                      : { ...styleCheckBoxFalse }
                  }
                  // label={answer?.content ? answer?.content : answer}
                />
                <span className="multiple-choice-ans fill-overflow-image multiple-choice-card">
                  {parseHtml(answer?.content ?? answer)}
                </span>
              </Label>
            ))
          : (question?.typeAnswer ||
              unitSelected?.complete?.question?.typeAnswer) ===
            QUESTION_ANSWER.RADIO
          ? listAnswer?.map((answer, index) => (
              <>
                <Label className="col multiple-checkbox explanation-card pr-0">
                  <Input
                    key={index}
                    className="custom-control-Primary"
                    type={'radio'}
                    checked={
                      test?.userQuestion?.reAttempt &&
                      !test?.userQuestion?.reAttempted &&
                      test?.userQuestion?.status !== 'DRAFT'
                        ? null
                        : (multi?.content || multi) == answer
                    }
                    onChange={() => setMulti(answer)}
                    id={`MTP-${index}`}
                    name="MTP"
                    style={{
                      backgroundColor:
                        test?.userQuestion?.reAttempt &&
                        !test?.userQuestion?.reAttempted &&
                        test?.userQuestion?.status !== 'DRAFT'
                          ? null
                          : (multi?.content || multi) == answer
                          ? `${themeStatus}`
                          : '',
                      borderColor:
                        test?.userQuestion?.reAttempt &&
                        !test?.userQuestion?.reAttempted &&
                        test?.userQuestion?.status !== 'DRAFT'
                          ? null
                          : (multi?.content || multi) == answer
                          ? `${themeStatus}`
                          : '',
                      marginTop: 0,
                    }}
                    // label={answer?.content ? answer?.content : answer}
                  />

                  <span className="multiple-choice-ans-radio multiple-choice-card drag-overflow-image">
                    {parseHtml(answer?.content ?? answer)}
                  </span>

                  {question?.data?.map(
                    (item) =>
                      item?.content == (answer?.content || answer) && (
                        <div>
                          <Popover
                            content={
                              <div
                                className={`Popover-responsive ${styles.Popover_responsive}`}
                                onClick={hide}
                              >
                                {parseHtml(item?.explanation)}
                              </div>
                            }
                            trigger="click"
                            open={open}
                            onOpenChange={handleOpenChange}
                          >
                            {item?.explanation?.length > 0 && (
                              <HelpCircle
                                aria-label="View explanation"
                                className="multi-icon"
                                size={16}
                                style={{
                                  color: 'var(--course-unit-status-icon-clr)',
                                }}
                              />
                            )}
                          </Popover>
                        </div>
                      ),
                  )}
                </Label>
              </>
            ))
          : test?.userQuestion?.result?.length
          ? listAnswer?.map((answer, index) => (
              <>
                {test?.userQuestion?.reAttempt &&
                !test?.userQuestion?.reAttempted &&
                test?.userQuestion?.status !== 'DRAFT' &&
                !firstAttempt ? (
                  <Label className="col multiple-checkbox">
                    <Input
                      key={index}
                      className="custom-control-Primary"
                      type={'checkbox'}
                      checked={false}
                      // defaultChecked={}
                      onChange={() => {
                        handler(index);
                        setFirstAttempt(true);
                      }}
                      id={`MTP-${index}`}
                      name="MTP"
                      style={{
                        accentColor: `${themeStatus}`,
                        height: 16,
                        width: 16,
                        marginTop: 0,
                      }}
                      // label={answer?.content ? answer?.content : answer}
                    />
                    <span className="multiple-choice-ans fill-overflow-image multiple-choice-card">
                      {parseHtml(answer?.content ?? answer)}
                    </span>
                    {question?.data.map(
                      (item) =>
                        item?.content == (answer?.content || answer) && (
                          <div>
                            <Popover
                              {...(isFullscreenMode?.active
                                ? {
                                    getPopupContainer: () =>
                                      containerRef.current,
                                  }
                                : {})}
                              placement={
                                isFullscreenMode?.active ? 'left' : 'top'
                              }
                              content={
                                <div
                                  onClick={hide}
                                  className={`Popover-responsive ${styles.Popover_responsive}`}
                                >
                                  {parseHtml(item?.explanation)}
                                </div>
                              }
                              trigger="click"
                              open={open}
                              onOpenChange={handleOpenChange}
                            >
                              {item?.explanation?.length > 0 && (
                                <HelpCircle
                                  aria-label="View explanation"
                                  className="multi-icon"
                                  size={16}
                                  style={{
                                    color: 'var(--course-unit-status-icon-clr)',
                                  }}
                                />
                              )}
                            </Popover>
                          </div>
                        ),
                    )}
                  </Label>
                ) : (
                  <Label className="col multiple-checkbox">
                    <Input
                      key={index}
                      className="custom-control-Primary"
                      type={'checkbox'}
                      checked={answerHandler(index)}
                      onChange={() => handler(index)}
                      id={`MTP-${index}`}
                      name="MTP"
                      style={{
                        accentColor: `${themeStatus}`,
                        height: 16,
                        width: 16,
                        marginTop: 0,
                      }}
                      // label={answer?.content ? answer?.content : answer}
                    />
                    <span className="multiple-choice-ans fill-overflow-image multiple-choice-card">
                      {parseHtml(answer?.content ?? answer)}
                    </span>
                    {question?.data.map(
                      (item) =>
                        item?.content == (answer?.content || answer) && (
                          <div ref={containerRef}>
                            <Popover
                              {...(isFullscreenMode?.active
                                ? {
                                    getPopupContainer: () =>
                                      containerRef.current,
                                  }
                                : {})}
                              placement={
                                isFullscreenMode?.active ? 'left' : 'top'
                              }
                              content={
                                <div
                                  onClick={hide}
                                  className={`Popover-responsive ${styles.Popover_responsive}`}
                                >
                                  {parseHtml(item?.explanation)}
                                </div>
                              }
                              trigger="click"
                              open={open}
                              onOpenChange={handleOpenChange}
                            >
                              {item?.explanation?.length > 0 && (
                                <HelpCircle
                                  aria-label="View explanation"
                                  className="multi-icon"
                                  size={16}
                                  style={{
                                    color: 'var(--course-unit-status-icon-clr)',
                                  }}
                                />
                              )}
                            </Popover>
                          </div>
                        ),
                    )}
                  </Label>
                )}
              </>
            ))
          : listAnswer?.map((answer, index) => (
              <>
                <Label
                  style={{ display: 'flex', alignItems: 'center' }}
                  className="col multiple-checkbox"
                >
                  <Input
                    key={index}
                    className="custom-control-Primary"
                    type={'checkbox'}
                    onChange={() => changeHandler(answer)}
                    id={`MTP-${index}`}
                    name="MTP"
                    style={{
                      accentColor: `${themeStatus}`,
                      height: 16,
                      marginTop: 0,
                      width: 16,
                    }}
                    // label={answer?.content ? answer?.content : answer}
                  />
                  <span className="multiple-choice-ans fill-overflow-image multiple-choice-card">
                    {parseHtml(answer?.content ?? answer)}
                  </span>
                  {question?.data.map(
                    (item) =>
                      item?.content == (answer?.content || answer) && (
                        <div>
                          <Popover
                            content={
                              <div
                                onClick={hide}
                                className={`Popover-responsive ${styles.Popover_responsive}`}
                              >
                                {parseHtml(item?.explanation)}
                              </div>
                            }
                            trigger="click"
                            open={open}
                            onOpenChange={handleOpenChange}
                          >
                            {item?.explanation?.length > 0 && (
                              <HelpCircle
                                aria-label="View explanation"
                                className="multi-icon"
                                size={16}
                                style={{
                                  color: 'var(--course-unit-status-icon-clr)',
                                }}
                              />
                            )}
                          </Popover>
                        </div>
                      ),
                  )}
                </Label>
              </>
            ))}
      </div>
    </>
  );
};

export default MultipleChoice;
